import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import api, { money } from "@/lib/api";

export default function MyOrders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([])); }, []);

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-10">
      <h1 className="font-heading font-extrabold text-3xl tracking-tight flex items-center gap-2"><Package className="text-primary" /> My Orders</h1>
      <div className="mt-8 space-y-4">
        {orders === null && <div className="text-muted-foreground">Loading…</div>}
        {orders && orders.length === 0 && (
          <div className="text-center py-16 text-muted-foreground">
            No orders yet. <Link to="/shop/rice" className="text-primary font-semibold">Start shopping</Link>
          </div>
        )}
        {orders && orders.map((o) => (
          <div key={o.order_id} className="bg-card border border-border rounded-lg p-5" data-testid={`order-${o.order_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div>
                <div className="font-heading font-bold font-mono-points">#{o.order_id}</div>
                <div className="text-xs text-muted-foreground">{o.created_at?.slice(0, 10)} · {o.items.length} item(s)</div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-semibold px-2 py-1 rounded-md bg-muted capitalize">{o.order_status}</span>
                <span className="text-xs font-semibold px-2 py-1 rounded-md bg-primary/15 text-primary capitalize">{o.payment_status}</span>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {o.items.map((it) => (
                <div key={it.product_id} className="flex items-center gap-2 bg-muted rounded-md p-1.5 pr-3">
                  <img src={it.image} alt="" className="w-9 h-9 rounded object-cover" />
                  <div className="text-xs"><div className="font-semibold">{it.name}</div><div className="text-muted-foreground">×{it.quantity}</div></div>
                </div>
              ))}
            </div>
            <div className="mt-4 border-t border-border pt-3 grid grid-cols-3 text-sm">
              <div><div className="text-muted-foreground text-xs">Subtotal</div><div className="font-mono-points font-semibold">{money(o.subtotal)}</div></div>
              <div><div className="text-muted-foreground text-xs">RicePoints used</div><div className="font-mono-points font-semibold text-primary">{money(o.points_used)}</div></div>
              <div><div className="text-muted-foreground text-xs">Payable</div><div className="font-mono-points font-bold">{money(o.payable)}</div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
